/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AddInputs */

const en_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const es_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir`)
};

const fr_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter`)
};

const de_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen`)
};

const ja_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加`)
};

const zh_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加`)
};

const ar_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافة`)
};

const id_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah`)
};

const it_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi`)
};

const ru_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить`)
};

const pt_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar`)
};

const ko_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추가`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {AddInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const add = /** @type {((inputs?: AddInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AddInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add(inputs)
	if (locale === "es") return es_add(inputs)
	if (locale === "fr") return fr_add(inputs)
	if (locale === "de") return de_add(inputs)
	if (locale === "ja") return ja_add(inputs)
	if (locale === "zh") return zh_add(inputs)
	if (locale === "ar") return ar_add(inputs)
	if (locale === "id") return id_add(inputs)
	if (locale === "it") return it_add(inputs)
	if (locale === "ru") return ru_add(inputs)
	if (locale === "pt") return pt_add(inputs)
	return ko_add(inputs)
});